import React,{useState, useEffect} from 'react';
import { motion } from 'framer-motion';

import { images } from '../../constants';
import './About.scss';

const abouts = [
  {
    title: 'Developement', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam tristique nulla id varius gravida. Curabitur non pellentesque eros, eget auctor arcu. Aliquam erat volutpat.', imageUrl: images.about001
  },
    
  {
    title: 'UI/UX Designing', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam tristique nulla id varius gravida. Curabitur non pellentesque eros, eget auctor arcu. Aliquam erat volutpat.', imageUrl: images.about002
  },

  {
    title: 'Programmer', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam tristique nulla id varius gravida. Curabitur non pellentesque eros, eget auctor arcu. Aliquam erat volutpat.', imageUrl: images.about003
  },
  
  {
    title: 'Extras', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam tristique nulla id varius gravida. Curabitur non pellentesque eros, eget auctor arcu. Aliquam erat volutpat.', imageUrl: images.about004
  }
];

const About = () => {
  return (
    <div className="about" id ='about' >
      <h2 className="head-text" >
        I know that <span>Good Developement</span><br/>means<span> Good Buisness</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about,index) => (
          <motion.div
            whileInView={{  y: [200,0], opacity: [0, 1] }}
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.9, type: 'spring' }}
            className="app__profiles-item"
            key={about.title + index}
            
          >
            <img src={about.imageUrl} alt={about.title} />

            <h2 style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>

    </div>
  )
}

export default About